<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  to: string | HTMLElement | null
  disabled?: boolean
}>()

const target = computed(() => (props.to ?? 'body'))
</script>

<template>
  <Teleport :to="target">
    <slot />
  </Teleport>
</template>